import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logoutUser } from "../../slices/thunks";

const Logout = () => {
  const dispatch = useDispatch();
  const isUserLogout = useSelector((state) => state.Login.isUserLogout);

  useEffect(() => {
    dispatch(logoutUser());
  }, [dispatch]);

  if (isUserLogout) {
    return <Navigate to="/login" />;
  }

  return null;
};

export default Logout;
